import { useAuth } from '@/shared/lib/auth';
import { useNpsMe } from '../api/use-nps';

/** MASTER NPS — vê todas as pesquisas e gerencia qualquer passbook/cliente. */
export const NPS_MASTER_EMAIL = 'admin@fixecrm.com';

export function isNpsMasterEmail(email?: string | null): boolean {
  return email?.trim().toLowerCase() === NPS_MASTER_EMAIL;
}

/** MASTER NPS por e-mail (não depende de roles Keycloak). */
export function useNpsAdmin() {
  const { data: me, isLoading: meLoading } = useNpsMe();
  const { user, isLoading: authLoading } = useAuth();

  const isAdmin = isNpsMasterEmail(user?.email) || isNpsMasterEmail(me?.email);
  return { me, isAdmin, isLoading: meLoading || authLoading };
}

export function useNpsAdminGuard() {
  const { isAdmin, isLoading } = useNpsAdmin();
  return { allowed: isAdmin, isLoading };
}
